export const email : string = 'psyscribe@outlook.com'
export const phone : string = '+486579209'